module.exports = __webpack_public_path__ + "static/media/crocodile(27).a04c4ecf.PNG";